/*
 * Esse Werks — pretty URL map + address-bar polish.
 *
 * Phase 1 sub-phase 1F: marketable short URLs for the customer-facing
 * pages and collections. The pattern is "301 + history.replaceState +
 * canonical preserved":
 *
 *  - 301 redirects (Shopify URL Redirects) handle the typing case:
 *      /shop → /pages/shop, /about → /pages/about, etc.
 *  - This script handles the address-bar polish: after the canonical
 *    page loads, if a short URL maps to the current location, rewrite
 *    the address bar via history.replaceState to the short form.
 *  - <link rel="canonical"> on every page continues to point to the
 *    Shopify-canonical URL — SEO is unaffected (no duplicate-content
 *    risk; Google sees one canonical).
 *
 * Whitelist: this only runs on content pages. NEVER on cart / checkout
 * / account / customer-account / orders — those have session and
 * redirect logic that must not be touched.
 *
 * The map is the single source of truth. Add entries here (short → real)
 * when a new marketable URL needs the address-bar polish AND a matching
 * Shopify URL Redirect (managed via scripts/phase1-1f-pretty-urls.py).
 */
(function () {
  'use strict';

  // short → Shopify canonical
  var MAP = {
    '/shop':                       '/pages/shop',
    '/shop-by-brand':              '/pages/shop-by-brand',
    '/shop-by-category':           '/pages/shop-by-category',
    '/shop-by-vehicle':            '/pages/shop-by-vehicle',
    '/about':                      '/pages/about',
    '/contact':                    '/pages/contact',
    '/events':                     '/pages/events',
    '/how-we-work':                '/pages/how-we-work',
    '/tunes':                      '/collections/ecu-dme',
    '/kits':                       '/collections/bundles',
    '/bundles':                    '/collections/bundles',
    '/b48-tuning':                 '/pages/b48-tuning',
    '/b48-tune':                   '/pages/b48-tune',
    '/b48-tuner':                  '/pages/b48-tuner',
    '/south-florida-bmw-tuner':    '/pages/south-florida-bmw-tuner',
    '/stage-1':                    '/pages/tuning-stage-1',
    '/stage-2':                    '/pages/tuning-stage-2',
    '/stage-3':                    '/pages/tuning-stage-3'
  };

  // Build reverse lookup: canonical path → short path
  var REVERSE = {};
  Object.keys(MAP).forEach(function (short) { REVERSE[MAP[short]] = short; });

  // Blog articles are intentionally NOT polished. Shopify does not serve
  // /esse-werks-tech-essays/<handle> (only /blogs/... is a real page), and a
  // URL Redirect is NOT auto-created when an article publishes — so a
  // polished address bar is a 404 waiting to be copied and shared for any
  // article whose redirect hasn't been backfilled. Articles must show their
  // real (canonical) /blogs/... URL. See _status/REPORT-SEO-CANONICAL-1.md.

  // Templates that are SAFE to polish. Set on <html data-template="..."> by
  // layout/theme.liquid. Everything else (cart, checkout, account, etc.)
  // is excluded — Shopify session + redirect logic must not be touched.
  var SAFE_TEMPLATES = {
    'index': 1, 'page': 1, 'collection': 1, 'product': 1, 'search': 1
  };

  function currentShortFor(path) {
    return REVERSE[path] || null;
  }

  function polish() {
    try {
      var html = document.documentElement;
      var template = (html && html.getAttribute('data-template')) || '';
      if (!SAFE_TEMPLATES[template]) return;

      var loc = window.location;
      // Skip cart/checkout/account paths defensively, even if data-template
      // somehow misclassifies them.
      var path = loc.pathname;
      if (
        path.indexOf('/cart') === 0 ||
        path.indexOf('/checkout') === 0 ||
        path.indexOf('/account') === 0 ||
        path.indexOf('/orders') === 0 ||
        path.indexOf('/policies') === 0 ||
        path.indexOf('/challenge') === 0 ||
        path.indexOf('/password') === 0
      ) return;

      var shortPath = currentShortFor(path);
      if (!shortPath) return;
      if (path === shortPath) return; // already polished or arrived via short link

      // Preserve query + hash so deep links (e.g. ?livery=performance#stage-2)
      // survive the polish.
      var polished = shortPath + (loc.search || '') + (loc.hash || '');
      history.replaceState(null, '', polished);
    } catch (_) {
      /* Silent — polish is cosmetic. Any error should not break the page. */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', polish);
  } else {
    polish();
  }
})();
